module.exports = __webpack_public_path__ + "static/media/icon_video_black.0d9baaa3.svg";